import { styled } from "@mui/material/styles";


export const Wrapper = styled("div")(() => ({
  padding: "12px 16px",
  height: "calc(100vh - 168px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}))

export const Icon = styled("span")(() => ({
  backgroundColor:"#FEF3F2",
  width: 72,
  height: 72,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 32,
  "& svg": {
    width: 35,
    height: 35,
    color: "#F04438",
  },
}))


export const Title = styled("h3")(() => ({
  color: "#F04438",
  font: "700 24px/33px Manrope",
  marginBottom: 20,
}))

export const Text = styled("span")(() => ({
  color: "#465869",
  font: "300 20px/28px Manrope",
  marginBottom: 40,
}))

export const Content = styled("div")(() => ({
  width: 342,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
}))


